module.exports = __webpack_public_path__ + "static/media/acerca.9a95266d.svg";